export default "__VITE_ASSET__B2nI_oAH__"